import React, { useEffect, useState } from "react";
import WalkinsCard from "../widgets/walkInsCard/WalkinsCard";
import parse from 'html-react-parser';

const JobDes = ({walkin}) => {
 
  const description = ()=>{
    const formattedDescription =  walkin?.walkInDescription?.replace(/\n/g, '<br>');
  return  parse(formattedDescription)


  }
  return (
    <>
  { walkin ?
    <div className="jobdes">
      <div class="section">
        <h1>{walkin.employer_name}</h1>
        {/* <p><strong>Date:</strong> 9th Nov 2024</p> */}
        <h3>Position: {walkin.walkInTitle}</h3>
    </div>
     <div>
     <h1>Description:</h1>
      {walkin?.walkInDescription && description()}</div>
    <div class="section">
        <h3>Role Details:</h3>
        <p><strong>Role:</strong> {walkin.walkInTitle}</p>
        <p><strong>Employment Type:</strong> {walkin.employmentType}</p>
        <p><strong>Contact No:</strong> {walkin.contactNumber}</p>
    </div>


    </div>:""
  }</>
  );
};
function Descrpition({walkinlist}) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 435);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
 
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className="Descrpition-containner">
      {/* <JobCard></JobCard> */}
      <WalkinsCard but_lable="View map" detials={walkinlist?.walkin} landingage="d" ></WalkinsCard>
     {walkinlist && <JobDes walkin={walkinlist?.walkin}></JobDes>}
   {!isSmallMobile &&   <WalkinsCard but_lable="View map"  landingage=" d " detials={walkinlist?.walkin} flag={false}></WalkinsCard>}
    </div>
  );
}

export default Descrpition;
